import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../../chunks/tslib.es6.js";
import e from "../../../core/Collection.js";
import { referenceSetter as s } from "../../../core/collectionUtils.js";
import { init as i } from "../../../core/watchUtils.js";
import { property as r } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import "../../../core/accessorSupport/ensureType.js";
import { subclass as a } from "../../../core/accessorSupport/decorators/subclass.js";
import { Container as o } from "../engine/Container.js";
import p from "../../layers/support/ClipArea.js";
import h from "../../layers/support/ClipRect.js";
import n from "../../layers/support/Geometry.js";
import d from "../../layers/support/Path.js";

var c = e.ofType({
  key: "type",
  base: p,
  typeMap: {
    rect: h,
    path: d,
    geometry: n
  }
}),
    l = function l(e) {
  var p = /*#__PURE__*/function (_e) {
    _inherits(p, _e);

    var _super = _createSuper(p);

    function p() {
      var _this;

      _classCallCheck(this, p);

      _this = _super.apply(this, arguments), _this.clips = new c(), _this.moving = !1, _this.attached = !1, _this.lastUpdateId = -1, _this.updateRequested = !1;
      return _this;
    }

    _createClass(p, [{
      key: "initialize",
      value: function initialize() {
        var _this2 = this;

        var t;
        this.container || (this.container = new o()), this.container.fadeTransitionEnabled = !0, this.container.opacity = 0, this.container.clips = this.clips, this.handles.add([i(this, "suspended", function (t) {
          _this2.container && (_this2.container.visible = !t), _this2.view && !t && _this2.updateRequested && _this2.view.requestUpdate();
        }, !0), i(this, ["layer.opacity", "container"], function () {
          var t, e;
          _this2.container && (_this2.container.opacity = null != (t = null == (e = _this2.layer) ? void 0 : e.opacity) ? t : 1);
        }, !0), i(this, ["layer.blendMode"], function (t) {
          _this2.container && (_this2.container.blendMode = t);
        }, !0), i(this, ["layer.effect"], function (t) {
          _this2.container && (_this2.container.effect = t);
        }, !0), this.clips.on("change", function () {
          _this2.container.clips = _this2.clips, _this2.notifyChange("clips");
        })]), null != (t = this.view) && t.whenLayerView ? this.view.whenLayerView(this.layer).then(function (t) {
          t !== _this2 || _this2.attached || _this2.destroyed || (_this2.attach(), _this2.requestUpdate(), _this2.attached = !0);
        }, function () {}) : this.when().then(function () {
          _this2.attached || _this2.destroyed || (_this2.attach(), _this2.requestUpdate(), _this2.attached = !0);
        }, function () {});
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.attached && (this.detach(), this.attached = !1), this.handles.remove("initialize"), this.updateRequested = !1;
      }
    }, {
      key: "updating",
      get: function get() {
        return !this.attached || !this.suspended && (this.updateRequested || this.isUpdating()) || !(!this.updatingHandles || !this.updatingHandles.updating);
      }
    }, {
      key: "isVisibleAtScale",
      value: function isVisibleAtScale(t) {
        var e = !0;
        var s = this.layer,
            i = s.minScale,
            r = s.maxScale;

        if (null != i && null != r) {
          var _s = !i,
              _a = !r;

          !_s && t <= i && (_s = !0), !_a && t >= r && (_a = !0), e = _s && _a;
        }

        return e;
      }
    }, {
      key: "requestUpdate",
      value: function requestUpdate() {
        this.destroyed || this.updateRequested || (this.updateRequested = !0, this.suspended || this.view.requestUpdate());
      }
    }, {
      key: "processUpdate",
      value: function processUpdate(t) {
        !this.isFulfilled() || this.isResolved() ? (this._set("updateParameters", t), this.updateRequested && !this.suspended && (this.updateRequested = !1, this.update(t))) : this.updateRequested = !1;
      }
    }, {
      key: "hitTest",
      value: function hitTest(t, e) {
        return Promise.resolve(null);
      }
    }, {
      key: "isUpdating",
      value: function isUpdating() {
        return !1;
      }
    }, {
      key: "isRendering",
      value: function isRendering() {
        return !1;
      }
    }, {
      key: "canResume",
      value: function canResume() {
        return !!_get(_getPrototypeOf(p.prototype), "canResume", this).call(this) && this.isVisibleAtScale(this.view.scale);
      }
    }]);

    return p;
  }(e);

  return t([r({
    type: c,
    set: function set(t) {
      var e = s(t, this._get("clips"), c);

      this._set("clips", e);
    }
  })], p.prototype, "clips", void 0), t([r()], p.prototype, "moving", void 0), t([r()], p.prototype, "attached", void 0), t([r()], p.prototype, "container", void 0), t([r()], p.prototype, "suspended", void 0), t([r({
    readOnly: !0
  })], p.prototype, "updateParameters", void 0), t([r()], p.prototype, "updateRequested", void 0), t([r()], p.prototype, "updating", null), t([r()], p.prototype, "view", void 0), p = t([a("esri.views.2d.layers.LayerView2D")], p), p;
};

export { l as LayerView2DMixin };